<template>
	<div>
		<v-layout wrap py-3 px-3>
			<v-flex xs12 px-2>
				<span class="caption">Código:</span>
				<BaseInput
				readonly
				:height="33"
				v-model="model.code"
				/>
				<span class="caption error--text" v-if="$v.model.code.$invalid">
					Esta campo es requerido.
				</span>
			</v-flex>
			<v-flex xs12 px-2 mt-2>
				<span class="caption">Nombre:</span>
				<BaseInput
				:height="33"
				v-model="model.name"
				/>
				<span class="caption error--text" v-if="$v.model.name.$invalid">
					Esta campo es requerido.
				</span>
			</v-flex>
			<v-flex xs12 px-2 mt-2>
				<span class="caption">Estado:</span>
				<BaseSelect
				item-text="name"
				item-value="id"
				:items="states"
				:height="33"
				v-model="model.flagActive"
				/>
				<span class="caption error--text" v-if="$v.model.flagActive.$invalid">
					Esta campo es requerido.
				</span>
			</v-flex>
			<v-flex xs12 px-2 mt-2>
				<span class="caption">Cuenta Contable:</span>
				<BaseSelect
					autocomplete
					item-text="fullName"
					item-value="code"
					:height="38"
					:items="accounts"
					v-model="model.account"
					return-object
				/>
			</v-flex>
			<v-flex xs12 px-2 mt-2>
				<span class="caption">Nivel para Nómina:</span>
				<BaseInput
				:height="33"
				v-model="model.level"
				/>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
			:isLoading="loading"
			@cancel-button-clicked="$emit('close-modal')"
			@accept-button-clicked="$emit('create-cost')"
			:is-loading="disabled"
			></modal-sidebar-button>
		</section>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import BaseInput from '@/components/shared/inputs/base-input';
import BaseSelect from '@/components/shared/inputs/base-select';

function created() {
	this.loadAccounts();
}

async function editCenter() {
	this.$emit('edit-center');
}

function disabled() {
	return this.$v.$invalid;
}

function data() {
	return {
		states: [
			{
				id: 1,
				name: 'Activo',
			},
			{
				id: 0,
				name: 'Inactivo',
			},
		],
		accounts: [],
	};
}
async function loadAccounts() {
	const { id } = this.subsidiary;
	const params = { status: 1 };
	const url = `accounting-plan/${id}/subsidiary`;
	try {
		({ data: this.accounts } = await this.$http.get(url, { params }));
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function validations() {
	return {
		model: {
			code: { required },
			name: { required },
			flagActive: { required },
		},
	};
}

export default {
	name: 'create-cost-center',
	data,
	created,
	components: {
		BaseInput,
		BaseSelect,
	},
	computed: {
		disabled,
	},
	methods: {
		editCenter,
		loadAccounts,
	},
	props: {
		model: {
			type: Object,
			default: () => {},
		},
		idCenter: [Number, String],
		disabledCode: {
			type: Boolean,
			default: false,
		},
		subsidiary: {
			type: Object,
			default: {},
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	validations,
};
</script>


// WEBPACK FOOTER //
// src/components/new-cost-center/create-cost-center.vue